import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'
import TextInput from '../../../UI/TextInput'
import RadioButton from '../../../UI/RadioButton'
import DropInComponent from '../../../payment/DropInComponent/DropInComponent';

class ReviewPay extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.onTypeChoice = this.onTypeChoice.bind(this)
    this.handleFormChange = this.handleFormChange.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps.currentState)
  }

  onTypeChoice(event) {
    this.setState(
      {
        paymentType: event.target.value
      },
      () => this.props.updateState(this.state)
    )
  }

  handleNext = () => {
    // Go to success page?
    this.props.history.push(`/`)
  }

  handleFormChange(event) {
    let name = event.target.name
    this.setState(
      {
        [name]: event.target.value
      },
      () => this.props.updateState(this.state)
    )
  }

  render() {
    const { t, currentState } = this.props

    return (
      <div className="payments">
        <DropInComponent
          amount={this.props.amountToPay}
          handlePostPayment={this.handleNext}
          completeTransaction={this.props.saveBookingSteps}
        />
      </div>
    )
  }
}

const enhance = compose(
  translate('booking_steps'),
  withRouter
)

export default enhance(ReviewPay)



// WEBPACK FOOTER //
// src/components/Guru/BookingSteps/Steps/ReviewPay.jsx